import { FormattedMessage } from "react-intl";

import * as sx from "./key-value-label.sx";
import type { KeyValueContainerProps, KeyValueLabelProps } from "./types";

export function KeyValueLabel({
  label,
  labelId,
  className,
  id,
  labelTransform,
}: {
  className?: string;
  id?: string;
  labelTransform?: KeyValueContainerProps["labelTransform"];
} & KeyValueLabelProps) {
  return (
    <sx.Label
      as="label"
      id={id}
      className={className}
      textTransform={labelTransform ?? "inherit"}
    >
      {label ?? <FormattedMessage id={labelId} />}:
    </sx.Label>
  );
}
